<template>
    <div class="bg-white mt-3 p-3 activity-type-create activity-category-view col-12">
        <div class="d-flex title-bar-block mb-2">
            <div class="icon-block me-4">
                <button id="cancel-label-btn" v-b-tooltip.hover title="Back" @click="cancel()">
                    <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                </button>
            </div>
            <div class="text">
                <span class="me-2">{{ $translate('category') }}</span>
            </div>
        </div>
        <b-overlay :show="loading" rounded="sm">
            <b-form class="form-sample" @submit.stop.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" md="12">
                        <label class="mb-3"><strong>{{ $translate('name') }}</strong><span class="red">*</span></label>
                        <b-form-input type="text" id="input-name" v-model="model.name" required v-custom-validation="$textRequired()"
                            :placeholder="$translate('enter_name')" trim></b-form-input>
                    </b-col>
                </b-row>
                <b-col md="12" class="mb-2 mt-4 text-center">
                    <b-button id="create-btn" class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionCreate && !model.id"
                        variant="primary" :disabled="loading ? true : false">{{ createLabel }}</b-button>
                    <b-button id="update-btn" class="btn btn-info btn-fw me-2" type="submit" v-if="hasPermissionUpdate && model.id"
                        variant="primary" :disabled="loading ? true : false">{{ updateLabel }}</b-button>
                    <b-button id="delete-btn" v-if="!!this.model.id && hasPermissionDelete" @click="deleteItem()" size="fw" class="me-2"
                        variant="delete-button">
                        {{ $translate('delete_item') }}
                    </b-button>
                    <b-button id="cancel-btn" variant="info" :disabled="loading ? true : false" @click="cancel()" class="btn-fw">{{
                        $cancelLabel() }}</b-button>
                </b-col>
            </b-form>
        </b-overlay>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'activityCategories-ViewItem',
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            model: {
                id: 0,
                name: null,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        /**
         * True if the user has permissions to create and clicked the create button, otherwise false.
         */
        canCreate() {
            console.log(this.user_permissions)
            return !this.model.id &&
                this.user_permissions.includes('create.order.categories')
                ? true
                : false
        },
        /**
         * True if the user has permission to view but not update an order category and clicked the view button on a category in the table, otherwise false.
         */
        canView() {
            return this.model.id &&
                !this.user_permissions.includes('update.order.categories') &&
                this.user_permissions.includes('view.order.categories')
                ? true
                : false
        },
        /**
         * True if the user has permission to update an order category and clicked the view button on a category in the table, otherwise false.
         */
        canUpdate() {
            return this.model.id &&
                this.user_permissions.includes('update.order.categories')
                ? true
                : false
        },
        createLabel() {
            if (this.loading) {
                return this.$translate('creating')
            } else {
                return this.$createLabel()
            }
        },
        updateLabel() {
            if (this.loading && this.model.id) {
                return this.$translate('updating')
            } else {
                return this.$updateLabel()
            }
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            const action = model.id ? 'update' : 'create'
            const message = model.id ? this.$translate('update_alert') : this.$translate('create_alert')
            const path = `orderCategory/${action}`
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            this.$emit('success', action, this.model.name, message)
                        })
                        .catch(error => {
                            this.$emit('error', error, this.model.name)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        async deleteItem() {
            try {
                // Initializing key variables
                console.log('Attempt to delete')
                const model = { ...this.model }
                const path = 'orderCategory/delete'
                const action = model.id ? 'update' : 'create'

                // Generate and display confirmation prompt
                const title = this.$translate('delete_activity_category')
                const message = `${this.$translate('delete_note')} ${model.name}?`
                // const errorMsg = 'Unable to delete Activity Category!'
                const alertMsg = this.$translate('delete_alert')
                const result = await this.confirmMessage(title, message)
                if (!result) {
                    throw new Error("")
                } 
                this.loading = true;
                
                await this.$store.dispatch(path, model.id)
                this.$emit(
                    'success',
                    this.$translate('deleted'),
                    model.name,
                    alertMsg,
                    action
                )
            } catch (error) {
                console.log('error-', error.message)
                this.doToast(this.$translate("error"), error.message, "danger");
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>
<style></style>
